<template>
  <div class="container-video mt-3 mb-3">
    <div class="row justify-content-center">      
      <div class="col-md-8 col-12">                    
        <div class="video-clip">        
          <div id="_1" class="container-interview">
            <div class="interview-thumb">
              <div class="control-video" @click="loadAndPlayVideo()">
                <div class="content">
                  <div class="tag">Ver la entrevista</div>
                  <div class="playInterview"><svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="currentColor" class="bi bi-play-circle-fill" viewBox="0 0 16 16">
                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M6.79 5.093A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814z"/>
                  </svg></div>
                </div>
              </div>
              <div class="">
                <img src="/wp-content/interactivos/factchecking-loreto/fotos/entrevista-1.jpg" />
              </div>
            </div>
            <div class="callback-overlay">
              <div class="hidden-video">
                <div>
                  <div class="embed-responsive embed-responsive-16by9 item-video">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <span class="video-title">Christian Pinasco Montenegro, empresario y presidente de la CDSL. (Créditos: El Foco)</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VideoClip01",
  methods: {
    loadAndPlayVideo() {
      // YouTube video ID
      const interview_id = '_1'
      const videoId = 'RxwC2GfswVs'

      // Get references to the button and video container
      const playButton = document.querySelector(`#${interview_id}`)
      const videoContainer = playButton.querySelector('.item-video')
      const parent_video = playButton.querySelector('.callback-overlay')
      const parent_thumb = playButton.querySelector('.interview-thumb')

      // Create an iframe element
      const iframe = document.createElement('iframe')
      
      // Set the iframe attributes
      iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1`
      iframe.frameborder = '0'
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
      iframe.allowFullscreen = true
      iframe.classList.add(`embed-responsive-item`)
      
      // Clear the video container and append the iframe
      videoContainer.innerHTML = ''
      videoContainer.appendChild(iframe)
      parent_thumb.classList.add('hide')
      parent_video.classList.add('show')
    
  }
  }
};
</script>


<style>

.control-video {
    position: absolute;
    width: 100%;
    z-index: 99;
    height: 100%;
    display: flex;
    align-items: center;
    background: #0000009e;
}

.control-video .content{
    width: 100%;
    max-width: 360px;
    margin: 0 auto;
}
.control-video .headline {
  font-size: 27px;
  font-weight: 600;
}

.control-video .playInterview {
  cursor: pointer;
}

.container-interview {
    position: relative;
    width: 100%;
}

@media (min-width: 320px) and (max-width: 820px) {
  .container-interview {
    left: -15px;
  }
}

.interview-thumb {
  width: 100%;
  background: #000;
  color: #fff;
  text-align: center;
  justify-content: center;
}
.interview-thumb.hide {
  display: none;
}

.callback-overlay {
  display: none;
}

.callback-overlay.show {
  display: block;
}

</style>
